import Vue from 'vue'
import Vuex from 'vuex'
import { request } from '@/api'
import { local, session } from '@/libs/location'

Vue.use(Vuex)

const getStyleTemplate = (data) => {
  data = data.replace(new RegExp('#ef4c4d', 'ig'), 'themeKey')
  return data
}

const writeNewStyle = (originalStyle, colors) => {
  let oldEl = document.getElementById('temp-style')
  let cssText = originalStyle
  cssText = cssText.replace(new RegExp('themeKey', 'ig'), colors)
  const style = document.createElement('style')
  style.innerText = cssText
  style.id = 'temp-style'
  oldEl ? document.head.replaceChild(style, oldEl) : document.head.appendChild(style)
}

export default new Vuex.Store({
  state: {
    settingData: {},
    loginData: {}
  },
  getters: {},
  mutations: {
    handleSettingData (state, data) {
      state.settingData = data
    },
    loginSetting (state, data) {
      state.loginData = data
    }
  },
  actions: {
    // 更换主题
    doChangeSkin ({ state }, colors) {
      local.setItem('theme', colors)
      request.get(`${window.document.location.origin}/qc-portal/theme.css`).then(({ data }) => {
        let style = getStyleTemplate(data)
        writeNewStyle(style, colors)
      })
    },
    // 查询当前登录配置
    doGetSetting ({ state, commit }) {
      return request.post('/sso/backgroundSet/findUsedBgSet').then(res => {
        console.log(res.data, 'res.data')
        const { code, data } = res.data
        const settingLogin = res.data.extra
        if (code === 'OK') {
          commit('handleSettingData', data)
          commit('loginSetting', settingLogin)
          return data
        }
      })
      // return new Promise((resolve, reject) => {
      //   let data = {
      //     id: 1, // 主键ID
      //     subject: 'hahaha', // 主题
      //     bgImage: '/qc-portal/assets1614604876598/img/login-center-bg.cf6cc1e6.jpg', // 登录背景图
      //     bgLayout: 'right', // 登录框位置right居右center居中
      //     loginBgColor: '#FFFFFF', // 登录框背景色
      //     inputBorderColor: '#666', // 输入框边框色
      //     inputBgColor: '#FCFCFC', // 输入框背景色
      //     fontColor: '#333333', // 字体颜色
      //     buttonColor: '#C8291D', // 按钮背景色
      //     indexBgImage: '../assets/images/home-bg.png', // 门户首页背景图
      //     indexHeadColor: '#C8291D', // 门户导航条背景色
      //     isPreset: 0, // 是否预置效果0否1是
      //     isUsing: 1, // 是否使用中0否1是
      //     backgroundSetList: null
      //   }
      //   commit('handleSettingData', data)
      //   resolve(data)
      // })
    },
    doGetUserInfo () {
      return request.post('/sso/userAttr/findUserInfo').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          session.setItem('userInfo', JSON.stringify(data))
          return data
        }
      })
    }
  }
})
